import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

// Kompakter, immer zentrierter Seitenkopf.
// Der optionale Action-Slot schwebt ab sm-Breakpoint rechts oben; auf mobile
// erscheint er zentriert unter dem Titel, damit nichts umbricht.
export default function PageHeader({ overline, title, subtitle, action }) {
  return (
    <Box sx={{ position: 'relative', mb: { xs: 3, md: 4 } }}>
      {action && (
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            display: { xs: 'none', sm: 'block' },
          }}
        >
          {action}
        </Box>
      )}

      <Stack alignItems="center" textAlign="center" spacing={0.25}>
        {overline && (
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ letterSpacing: 1.5, lineHeight: 1.4 }}
          >
            {overline}
          </Typography>
        )}
        <Typography
          component="h1"
          sx={{
            fontSize: { xs: '1.4rem', md: '1.75rem' },
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            color="text.secondary"
            sx={{ fontSize: '0.875rem', maxWidth: 560, pt: 0.25 }}
          >
            {subtitle}
          </Typography>
        )}
      </Stack>

      {action && (
        <Box
          sx={{
            display: { xs: 'flex', sm: 'none' },
            justifyContent: 'center',
            mt: 2,
          }}
        >
          {action}
        </Box>
      )}
    </Box>
  );
}
